import ApiService from "@/services/api.service";

const route = 'audits';

const audits = {
    get(_limit, _currentPage, _params) {
        return new Promise((resolve, reject) => {
            var params = "?limit=" + _limit + "&page=" + _currentPage;
            
            if(_params.functionality_id != null){
                params += "&functionality_id=" + _params.functionality_id;
            }
            
            if(_params.action_id != null){
                params += "&action_id=" + _params.action_id;
            }
            
            if(_params.user_id != null){
                params += "&user_id=" + _params.user_id;
            }
            
            if(_params.register_id != null){
                params += "&register_id=" + _params.register_id;
            }
            
            ApiService.get(route + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }
};

export default audits;